import { ComboboxItem } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { clinicQKeys } from "./queryKeys";


const queryFn = () => {
  return api.get("clinic/consumables");
};

const select = (res: any) => {
  //   console.log(res.data);

  if (res.data.length) {
    const newData: ComboboxItem[] = [];

    for (const { name, _id } of [...res.data].reverse()) {

      newData.push({ label: name, value: _id });
    }
    // console.log(newData);
    return newData;
  }
  return null;
};

export const useGetClinicConsumables = () => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: clinicQKeys.consumables(),
    queryFn,
    select,
    staleTime: Infinity,

    onError: (res: any) => {
      console.error("[From Get All Clinic Consumables]", res);
      handleErrors(res, "query");
    },
  });
};
